// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"193":"fa29e717","725":"1495ff33"}[chunkId] + ".js";
};